import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface IScheduleCellTextProps {
  minutes: number
  title?: string | null
  units?: 'total' | 'daily' | 'none'
  short?: boolean
  size?: '100' | '200' | '300' | '400'
  weight?: 'bold' | 'semibold' | 'medium' | 'normal'
}

const ScheduleCellText = ({
  minutes,
  title,
  units,
  short,
  size = '100',
  weight,
}: IScheduleCellTextProps) => {
  const formatUnits = () => {
    if (units === 'none') {
      return ''
    } else if (units === 'total') {
      return i18n.t('project_management.schedule.units.total')
    } else {
      return i18n.t('project_management.schedule.units.by_day')
    }
  }
  const flexDirection = short ? 'column' : 'row'

  const formatSecondsToHM = (seconds: number): [number, number] => {
    const positiveSeconds = Math.abs(seconds)
    const hours = Math.floor(+positiveSeconds / 3600)
    const minutes = Math.ceil(Math.floor(+positiveSeconds - hours * 3600) / 60)

    if (seconds < 0) {
      return [-Number(hours), Number(minutes)]
    }

    // const absText = minutes == 0 ? `${Number(hours)}h` : `${Number(hours)}h ${Number(minutes)}m`
    return [Number(hours), Number(minutes)]
  }

  const time = formatSecondsToHM(minutes * 60)
  const formatedUnits = formatUnits()

  return (
    <Box flexDirection={flexDirection} alignItems="flexStart">
      <Text.Normal size={size} weight={weight ? weight : 'medium'} color="grey1000" ellipsis>
        {time[0]}h
      </Text.Normal>
      {time[1] > 0 && (
        <Text.Normal size={size} weight={weight ? weight : 'medium'} color="grey1000" ellipsis>
          {' ' + time[1]}m
        </Text.Normal>
      )}
      {!short && formatedUnits !== '' && (
        <Text.Normal size={size} weight={weight ? weight : 'normal'} color="grey1000" ellipsis>
          {' ' + formatedUnits}
        </Text.Normal>
      )}
      {!short && title && (
        <Text.Normal size={size} weight={weight ? weight : 'medium'} color="grey1000" ellipsis>
          {title}
        </Text.Normal>
      )}
    </Box>
  )
}

export default ScheduleCellText
